import { render, staticRenderFns } from "./ContactUsBox.vue?vue&type=template&id=1d9a1d3b&scoped=true"
import script from "./ContactUsBox.vue?vue&type=script&lang=js"
export * from "./ContactUsBox.vue?vue&type=script&lang=js"
import style0 from "./ContactUsBox.vue?vue&type=style&index=0&id=1d9a1d3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a1d3b",
  null
  
)

export default component.exports